import { call, put, takeEvery } from 'redux-saga/effects'
import {
  // Category Actions
  getCategoryListRequest,
  getCategoryListSuccess,
  getCategoryListFailed,
  getCategoryDetailsRequest,
  getCategoryDetailsSuccess,
  getCategoryDetailsFailed,
  addCategoryRequest,
  addCategorySuccess,
  addCategoryFailed,
  updateCategoryRequest,
  updateCategorySuccess,
  updateCategoryFailed,
  deleteCategoryRequest,
  deleteCategorySuccess,
  deleteCategoryFailed,

  // Sub Category Actions
  getSubcategoryListRequest,
  getSubcategoryListSuccess,
  getSubcategoryListFailed,
  getSubcategoryDetailsRequest,
  getSubcategoryDetailsSuccess,
  getSubcategoryDetailsFailed,
  addSubcategoryRequest,
  addSubcategorySuccess,
  addSubcategoryFailed,
  updateSubcategoryRequest,
  updateSubcategorySuccess,
  updateSubcategoryFailed,
  deleteSubcategoryRequest,
  deleteSubcategorySuccess,
  deleteSubcategoryFailed,

  // Brand Actions
  getBrandListRequest,
  getBrandListSuccess,
  getBrandListFailed,
  getBrandDetailsRequest,
  getBrandDetailsSuccess,
  getBrandDetailsFailed,
  addBrandRequest,
  addBrandSuccess,
  addBrandFailed,
  updateBrandRequest,
  updateBrandSuccess,
  updateBrandFailed,
  deleteBrandRequest,
  deleteBrandSuccess,
  deleteBrandFailed,
  getProductListRequest,
  getProductListSuccess,
  getProductListFailed,
  getProductDetailsRequest,
  getProductDetailsSuccess,
  getProductDetailsFailed,
  getSuperCategoryListRequest,
  getSuperCategoryListSuccess,
  getSuperCategoryListFailed,
  getSuperCategoryDetailsRequest,
  getSuperCategoryDetailsSuccess,
  getSuperCategoryDetailsFailed,
  addSuperCategoryRequest,
  addSuperCategorySuccess,
  addSuperCategoryFailed,
  updateSuperCategoryRequest,
  updateSuperCategorySuccess,
  updateSuperCategoryFailed,
  activeInactiveSuperCategoryRequest,
  activeInactiveSuperCategorySuccess,
  activeInactiveSuperCategoryFailed,
  deleteSuperCategoryRequest,
  deleteSuperCategorySuccess,
  deleteSuperCategoryFailed,
} from './slice'

import { API } from '../../services'

// Super Category Sagas
function* handleGetSuperCategoryList({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.getSuperCategoryList, payload)
    if (response.data && response.status === 200) {
      yield put(getSuperCategoryListSuccess(response.data))
    } else {
      yield put(getSuperCategoryListFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getSuperCategoryListFailed({ message: error.message }))
  }
}

function* handleGetSuperCategoryDetails({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.getSuperCategoryDetails, payload)
    if (response.data && response.status === 200) {
      yield put(getSuperCategoryDetailsSuccess(response.data))
    } else {
      yield put(getSuperCategoryDetailsFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getSuperCategoryDetailsFailed({ message: error.message }))
  }
}

function* handleAddSuperCategory({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.addSuperCategory, payload)
    if ((response.data && response.status === 200) || response.status === 201) {
      yield put(addSuperCategorySuccess(response.data))
    } else {
      yield put(addSuperCategoryFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addSuperCategoryFailed({ message: error.message }))
  }
}

function* handleUpdateSuperCategory({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.updateSuperCategory, payload)
    if ((response.data && response.status === 200) || response.status === 201) {
      yield put(updateSuperCategorySuccess(response.data))
    } else {
      yield put(updateSuperCategoryFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateSuperCategoryFailed({ message: error.message }))
  }
}

function* handleActiveInactiveSuperCategory({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.activeInactiveSuperCategory, payload)
    if (response.data && response.status === 200) {
      yield put(activeInactiveSuperCategorySuccess(response.data))
    } else {
      yield put(activeInactiveSuperCategoryFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveSuperCategoryFailed({ message: error.message }))
  }
}

// Category Sagas
function* handleGetCategoryList({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.getCategoryList, payload)
    if (response.data && response.status === 200) {
      yield put(getCategoryListSuccess(response.data))
    } else {
      yield put(getCategoryListFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getCategoryListFailed({ message: error.message }))
  }
}

function* handleGetCategoryDetails({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.getCategoryDetails, payload)
    if (response.data && response.status === 200) {
      yield put(getCategoryDetailsSuccess(response.data))
    } else {
      yield put(getCategoryDetailsFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getCategoryDetailsFailed({ message: error.message }))
  }
}

function* handleAddCategory({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.addCategory, payload)
    if (response.data && response.status === 200) {
      yield put(addCategorySuccess(response.data))
    } else {
      yield put(addCategoryFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addCategoryFailed({ message: error.message }))
  }
}

function* handleUpdateCategory({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.updateCategory, payload)
    if (response.data && response.status === 200) {
      yield put(updateCategorySuccess(response.data))
    } else {
      yield put(updateCategoryFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateCategoryFailed({ message: error.message }))
  }
}

function* handleDeleteCategory({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.deleteCategory, payload)
    if (response.data && response.status === 200) {
      yield put(deleteCategorySuccess(response.data))
    } else {
      yield put(deleteCategoryFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteCategoryFailed({ message: error.message }))
  }
}

// Sub Category Sagas
function* handleGetSubcategoryList({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.getSubcategoryList, payload)
    if (response.data && response.status === 200) {
      yield put(getSubcategoryListSuccess(response.data))
    } else {
      yield put(getSubcategoryListFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getSubcategoryListFailed({ message: error.message }))
  }
}

function* handleGetSubcategoryDetails({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.getSubcategoryDetails, payload)
    if (response.data && response.status === 200) {
      yield put(getSubcategoryDetailsSuccess(response.data))
    } else {
      yield put(getSubcategoryDetailsFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getSubcategoryDetailsFailed({ message: error.message }))
  }
}

function* handleAddSubcategory({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.addSubcategory, payload)
    if (response.data && response.status === 200) {
      yield put(addSubcategorySuccess(response.data))
    } else {
      yield put(addSubcategoryFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addSubcategoryFailed({ message: error.message }))
  }
}

function* handleUpdateSubcategory({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.updateSubcategory, payload)
    if (response.data && response.status === 200) {
      yield put(updateSubcategorySuccess(response.data))
    } else {
      yield put(updateSubcategoryFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateSubcategoryFailed({ message: error.message }))
  }
}

function* handleDeleteSubcategory({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.deleteSubcategory, payload)
    if (response.data && response.status === 200) {
      yield put(deleteSubcategorySuccess(response.data))
    } else {
      yield put(deleteSubcategoryFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteSubcategoryFailed({ message: error.message }))
  }
}

// Brand Sagas
function* handleGetBrandList({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.getBrandList, payload)
    if (response.data && response.status === 200) {
      yield put(getBrandListSuccess(response.data))
    } else {
      yield put(getBrandListFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getBrandListFailed({ message: error.message }))
  }
}

function* handleGetBrandDetails({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.getBrandDetails, payload)
    if (response.data && response.status === 200) {
      yield put(getBrandDetailsSuccess(response.data))
    } else {
      yield put(getBrandDetailsFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getBrandDetailsFailed({ message: error.message }))
  }
}

function* handleAddBrand({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.addBrand, payload)
    if (response.data && response.status === 200) {
      yield put(addBrandSuccess(response.data))
    } else {
      yield put(addBrandFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addBrandFailed({ message: error.message }))
  }
}

function* handleUpdateBrand({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.updateBrand, payload)
    if (response.data && response.status === 200) {
      yield put(updateBrandSuccess(response.data))
    } else {
      yield put(updateBrandFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateBrandFailed({ message: error.message }))
  }
}

function* handleDeleteBrand({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.deleteBrand, payload)
    if (response.data && response.status === 200) {
      yield put(deleteBrandSuccess(response.data))
    } else {
      yield put(deleteBrandFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteBrandFailed({ message: error.message }))
  }
}

// Product Sagas

function* handleGetProductList({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.getProductList, payload)
    if (response.data && response.status === 200) {
      yield put(getProductListSuccess(response.data))
    } else {
      yield put(getProductListFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getProductListFailed({ message: error.message }))
  }
}

function* handleGetProductDetails({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.getProductDetails, payload)
    if (response.data && response.status === 200) {
      yield put(getProductDetailsSuccess(response.data))
    } else {
      yield put(getProductDetailsFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getProductDetailsFailed({ message: error.message }))
  }
}

function* handleDeleteSuperCategory({ payload }) {
  try {
    const response = yield call(API.marketPlaceApi.deleteSuperCategory, payload)
    if ((response.data && response.status === 200) || response.status === 201) {
      yield put(deleteSuperCategorySuccess(response.data))
    } else {
      yield put(deleteSuperCategoryFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteSuperCategoryFailed({ message: error.message }))
  }
}

export default function* marketplaceSaga() {
  yield takeEvery(getSuperCategoryListRequest, handleGetSuperCategoryList)
  yield takeEvery(getSuperCategoryDetailsRequest, handleGetSuperCategoryDetails)
  yield takeEvery(addSuperCategoryRequest, handleAddSuperCategory)
  yield takeEvery(updateSuperCategoryRequest, handleUpdateSuperCategory)
  yield takeEvery(activeInactiveSuperCategoryRequest, handleActiveInactiveSuperCategory)
  yield takeEvery(deleteSuperCategoryRequest, handleDeleteSuperCategory)
  // Category Watchers
  yield takeEvery(getCategoryListRequest, handleGetCategoryList)
  yield takeEvery(getCategoryDetailsRequest, handleGetCategoryDetails)
  yield takeEvery(addCategoryRequest, handleAddCategory)
  yield takeEvery(updateCategoryRequest, handleUpdateCategory)
  yield takeEvery(deleteCategoryRequest, handleDeleteCategory)

  // Sub Category Watchers
  yield takeEvery(getSubcategoryListRequest, handleGetSubcategoryList)
  yield takeEvery(getSubcategoryDetailsRequest, handleGetSubcategoryDetails)
  yield takeEvery(addSubcategoryRequest, handleAddSubcategory)
  yield takeEvery(updateSubcategoryRequest, handleUpdateSubcategory)
  yield takeEvery(deleteSubcategoryRequest, handleDeleteSubcategory)

  // Brand Watchers
  yield takeEvery(getBrandListRequest, handleGetBrandList)
  yield takeEvery(getBrandDetailsRequest, handleGetBrandDetails)
  yield takeEvery(addBrandRequest, handleAddBrand)
  yield takeEvery(updateBrandRequest, handleUpdateBrand)
  yield takeEvery(deleteBrandRequest, handleDeleteBrand)
  yield takeEvery(getProductListRequest, handleGetProductList)
  yield takeEvery(getProductDetailsRequest, handleGetProductDetails)
}
